import React from 'react';
export function PageLoader({
  label = 'Loading observatory data'
}: {
  label?: string;
}) {
  return <div className="mx-auto max-w-[1400px] px-5 py-16 md:px-8" role="status" aria-live="polite" data-id="element-648" data-mp="1ln7rywjaqhkj">
      <div className="h-10 w-72 max-w-full rounded bg-raised" data-id="element-649" data-mp="1gvzjc2psj08f" />
      <div className="mt-4 h-4 w-[28rem] max-w-full rounded bg-raised/70" data-id="element-650" data-mp="1gueosd3h7hak" />
      <div className="mt-10 h-64 w-full rounded-lg border border-line bg-surface" data-id="element-651" data-mp="1cuxhrf8eic3a" />
      <span className="sr-only" data-id="element-652" data-mp="17ww274a6ouwk">{label}…</span>
    </div>;
}